<div class="position-relative  panel-shadows-light overflow-x-hidden {{class}}">
  <div *ngIf="showHeader" class="{{headerClass}}">
    <app-modal-header (closeModal)="closeDialog($event)" [title]="title | truncate : 40"
    ></app-modal-header>
  </div>

  <div class="medium-font-size position-relative  ">
    <!-- NAME FIELDS OR GENERAL -->

    <div class="{{fieldsContainerClass}}">
      <ng-container
        *ngTemplateOutlet="fieldList; context{fields:nameFields,title:null}"
      ></ng-container>

      <ng-container *ngIf="getVisibleCount(statusFields) >= 3">
        <ng-container
          [ngTemplateOutletContext]="{fields:statusFields,title:'StatIus'}"
          [ngTemplateOutlet]="fieldList"
        ></ng-container>
      </ng-container>

      <ng-container *ngIf="getVisibleCount(fields) >= 3">
        <ng-container
          [ngTemplateOutletContext]="{fields:fields,title:'Details'}"
          [ngTemplateOutlet]="fieldList"
        ></ng-container>
      </ng-container>

      <ng-container *ngIf="getVisibleCount(baseFields) >= 3">
        <ng-container
          [ngTemplateOutletContext]="{fields:baseFields,title:'Entity Details'}"
          [ngTemplateOutlet]="fieldList"
        ></ng-container>
      </ng-container>
    </div>

    <!-- ARRAYS -->
    <div *ngIf="getVisibleCount(arrays) && !hideArrays" class="{{arraysContainerClass}}">
      <ng-container *ngFor="let arrayField of arrays">
        <div *ngIf="!arrayField?.sensitive && !arrayField?.hidden" class="{{arrayField?.class_}}">
          <div *ngIf="showGroupLabels" class="{{valuesClass}} {{groupLabelsClass}} {{animation}}" style="--order:1.8">
            <div class="d-flex align-items-center">
              <mat-icon *ngIf="arrayField?.icon" [svgIcon]="arrayField?.icon"
                        class="{{arrayField?.iconClass}} {{iconsClass}} me-3"></mat-icon>
              <mat-icon *ngIf="hasFieldWithIcon(arrays) && !arrayField?.icon"
                        class="{{iconsClass}} visibility-hidden me-3"
                        svgIcon="item"></mat-icon>
              <span> {{arrayField?.name }} ({{ arrayField.value.length}}) </span>
            </div>
          </div>
          <div class="h-100 w-100 position-relative {{innerArraysClassList}} ">
            <ng-container *ngIf="arrayField.hasTabularDisplay; else checkIfAttachmentArray">
              <ng-container [ngTemplateOutletContext]="{arrayField}" [ngTemplateOutlet]="tableDisplay"></ng-container>
            </ng-container>

            <ng-template #checkIfAttachmentArray>
              <div *ngIf="arrayField.semanticType==='attachmentArray' else checkIfCommentArray" class="row py-2">
                <ng-container [ngTemplateOutletContext]="{arrayField}"
                              [ngTemplateOutlet]="attachmentArray"></ng-container>
              </div>
            </ng-template>

            <ng-template #checkIfCommentArray>
              <div *ngIf="arrayField.semanticType==='commentArray' else checkIfStringArray" class="row py-2">
                <ng-container [ngTemplateOutletContext]="{arrayField}" [ngTemplateOutlet]="commentArray"></ng-container>
              </div>
            </ng-template>

            <ng-template #checkIfStringArray>
              <div *ngIf="arrayField.semanticType==='stringArray' else checkIfObjectArray" class="row py-2">
                <ng-container [ngTemplateOutletContext]="{arrayField}" [ngTemplateOutlet]="stringArray"></ng-container>
              </div>
            </ng-template>

            <ng-template #checkIfObjectArray>
              <div class="row mx-0 py-2 ">
                <ng-container [ngTemplateOutletContext]="{arrayField}" [ngTemplateOutlet]="objectArray"></ng-container>
              </div>
            </ng-template>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>


<!-- TEMPLATES -->
<!-- FIELDS TEMPLATE -->
<ng-template #fieldList let-fields="fields" let-hideAnimations="hideAnimations" let-icon="icon"
             let-iconClass="iconClass"
             let-title="title">
  <div *ngIf="fields?.length" class=" h-100  w-100 position-relative" style="--order:1.8">
    <div *ngIf="getVisibleCount(fields) && title && showGroupLabels"
         class="{{valuesClass}} {{groupLabelsClass}} {{animation}}" style="--order:2">
      <div class="d-flex align-items-center">
        <mat-icon *ngIf="icon" [svgIcon]="icon" class="{{iconClass}} {{iconsClass}} me-3"></mat-icon>
        <span> {{ title }} </span>
      </div>
    </div>

    <div class="row mx-0 {{fieldsGroupClass}}">
      <ng-container *ngFor="let field of fields; let i=index">
        <div *ngIf="!field?.sensitive && !field?.hidden"
             [ngClass]="{'border-left-gradient':hasLeftFieldsMark}"
             [style.--border-offset-value]="leftFieldMarkOffset"
             class="{{field?.class_}} {{hideAnimations? '':animation}} --order-{{(i/2)+1}}">
          <div class="h-100  d-flex align-items-center">
            <mat-icon *ngIf="field?.icon" [svgIcon]="field?.icon"
                      class="{{field?.iconClass}} {{iconsClass}} me-3"></mat-icon>
            <mat-icon *ngIf="hasFieldWithIcon(fields) && !field?.icon" class="{{iconsClass}} visibility-hidden me-3"
                      svgIcon="item"></mat-icon>
            <div class="h-100 px-0 col d-flex flex-column justify-content-between ">
              <div
                class="{{ (field?.class | stringBetween : '[' ) ?  (field?.class | stringBetween : '[') : fieldsInnerClass}}">
                <div *ngIf="!(field?.class | valueIncludes : 'no-label')"
                     class="{{labelsClass}}">{{ field?.name }}<span *ngIf="showColon"> : </span>
                </div>
                <div class="{{valuesClass}}">
                  <ng-container [ngTemplateOutletContext]="{field}" [ngTemplateOutlet]="valueDisplay"></ng-container>
                </div>
              </div>
              <mat-divider *ngIf="(showUnderlines && !field?.class?.includes('no-underline'))"
                           [hidden]="(field?.class | valueIncludes : 'no-label')"
                           class="{{dividerClass}}"
              ></mat-divider>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>


<!-- VALUE TEMPLATE -->
<ng-template #valueDisplay let-field="field">
  <span *ngIf="!ds.isObject(field.value); else showObject">
    <div *ngIf="fs.isPercentageField(field); else attachmentField" class="position-relative flex-center">
        <mat-progress-bar class="very-fat-bar" mode="determinate" value="{{ field?.value }}"></mat-progress-bar>
        <div class="faded small position-absolute">{{ field?.value + "%" }}</div>
    </div>
    <ng-template #attachmentField>
        <span (click)="viewAttachment(field.value,field.key)"
              *ngIf="fs.isAttachmentField(field); else valueField"
              class="d-flex align-items-center max-width-200 bg-gradient-faded rounded-slight cursor-pointer p-2"
              mat-ripple>
          <mat-icon class="ps-1 icon-smallll" svgIcon="attachment"></mat-icon>
          <span class="ps-2"> View Attachment </span>
        </span>
    </ng-template>
    <ng-template #valueField>
        <span *ngIf="ds.isBool(field.value); else text"
              [ngClass]="{'bg-white border-slightly-faded':field.value,'bg-slightly-light':!field.value}"
              class="rounded-slight p-1 px-3">
            {{ field.value ? ("YES") : ("NO")}}
        </span>
        <ng-template #text><span [innerHTML]="field.value | safeHtml"> </span></ng-template>
    </ng-template>
  </span>
  <ng-template #showObject>
      <span (click)="viewDetails(field.value)" *ngIf="viewInnerObjects"
            class="px-222 borderrr cursor-pointer rounded-slight d-inline-block"
            matRipple>
          <span class="d-flex align-items-center">
              <span [innerHTML]="fs.getFirstNameField(field.value)?.value | safeHtml" class="padd-left-5555"></span>
          </span>
      </span>
    <span *ngIf="!viewInnerObjects" [innerHTML]="fs.getFirstNameField(field.value)?.value | safeHtml"></span>
  </ng-template>
</ng-template>


<!-- ATTACHMENT ARRAY -->
<ng-template #attachmentArray let-arrayField="arrayField">
  <div *ngFor="let object of arrayField.value; let i = index" class="{{arrayField.class}}">
    <div (click)="viewAttachmentFromObject(object)"
         class="p-1 m-1 d-flex cursor-pointer bg-hover-slightly-faded-gradient
        align-items-center box-shadow-faded border-slightly-faded rounded-slight">
        <span class="box-shadow-faded bg-gradient-slightly-faded rounded-slight border-slightly-faded flex-center">
            <span class="box-35 round border-4 border-c flex-center"> <span class="faded">  {{i + 1}} </span> </span>
            <mat-icon *ngIf="arrayField?.icon" [svgIcon]="arrayField?.icon"
                      class="{{arrayField?.iconClass}} {{iconsClass}} me-2"></mat-icon>
            <mat-icon *ngIf="!arrayField?.icon" class="{{iconsClass}}  me-2" svgIcon="pdf"></mat-icon>
        </span>
      <div *ngIf="fs.getFirstNameField(object)?.value as name" class="h-100 p-1 m-1">
        <div class="text-capitalize">{{ object?.attachmentType?.title }} </div>
        <div class="small faded"> {{ name }} </div>
      </div>
    </div>
  </div>
</ng-template>


<!-- STRING ARRAY -->
<ng-template #stringArray let-arrayField="arrayField">
  <div *ngFor="let value of arrayField.value; let i = index" class="{{arrayField.class}}">
    <div class="p-1 m-1 d-flex  bg-hover-slightly-faded-gradient
        align-items-center box-shadow-faded border-slightly-faded rounded-slight">
        <span class="box-35 box-shadow-faded bg-gradient-slightly-faded round border-4 flex-center">
           <span class="faded">  {{i + 1}} </span>
        </span>
      <div class="h-100 p-1 m-1"> {{value}} </div>
    </div>
  </div>
</ng-template>


<!-- COMMENT ARRAY -->
<ng-template #commentArray let-arrayField="arrayField">
  <ng-container *ngFor="let object of arrayField.value; let i = index">
    <mat-expansion-panel (closed)="false"
                         (opened)="true" [hideToggle]="!object.isOwnComment"
                         [ngClass]="{'comment-in border-left-secondary ':!object?.isFirstCommenter,
        'comment-out border-right-primary ':object?.isFirstCommenter}"
                         class="col-12 px-0 my-1 {{animation}} --order-{{(i/2)+1.5}}">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <!-- notification -->
          <ng-container *ngTemplateOutlet="notification; context{object}"></ng-container>
          <div class="position-relative py-2">
            <div class="{{labelsClass}} w-100 position-relative">
              <span class="faded small pe-3"> {{i + 1}} </span>
              <span class="padd-left-5"> {{fs.getCommentField(object)?.value}} </span>
            </div>
            <div class="small faded mt-2 pl-3">
              <!-- <span *ngIf="object['createdBy']"> {{ object['createdBy'] | userByUid | async}} </span> -->
              <span *ngIf="object['createdAt']" class="pl-1"> {{ds.getDisplayDateTime(object['createdAt'])}} </span>
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <ng-template matExpansionPanelContent>
        <!-- actions at bottom of panel -->
        <ng-container *ngTemplateOutlet="actions; context{object}"></ng-container>
      </ng-template>

    </mat-expansion-panel>
  </ng-container>
</ng-template>


<!-- OBJECT ARRAY -->
<ng-template #objectArray let-arrayField="arrayField">
  <ng-container *ngFor="let object of arrayField.value; let i = index">
    <mat-expansion-panel (closed)="false"
                         (opened)="true" class="col-12 px-0 my-1 {{animation}} --order-{{(i/2)+1.5}}">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <!-- notification -->
          <ng-container *ngTemplateOutlet="notification; context{object}"></ng-container>
          <div class="position-relative">
            <div class="{{labelsClass}} w-100 position-relative">
              <span class="faded small pe-3"> {{i + 1}} </span>
              <span class="padd-left-5"> {{ fs.getFirstNameField(object)?.value }} </span>
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <ng-template matExpansionPanelContent>
        <!-- object fields -->
        <ng-container
          [ngTemplateOutletContext]="{
              fields:getVisibleFields(object,null,false) ,
              title:null,hideAnimations:true
            }"
          [ngTemplateOutlet]="fieldList"
        ></ng-container>
        <!-- actions at bottom of panel -->
        <ng-container *ngTemplateOutlet="actions; context{object}"></ng-container>

      </ng-template>
    </mat-expansion-panel>
  </ng-container>
</ng-template>


<!-- TABLE TEMPLATE -->
<ng-template #tableDisplay let-arrayField="arrayField">
  <table *ngIf="getVisibleFields(arrayField.value?.[0],arrayField.innerVisibleFields,false) as tableFields"
         class="w-100 {{arrayTablesClass}} {{animation}} --order-{{(0.5)+1.5}}">

    <thead class="{{tableHeadersClass}}">
    <th class="text-center"> #</th>
    <ng-container *ngFor="let field of tableFields; let j=index">
      <th class="d-xl-table-cell {{tableHeaderCellsClass}}"> {{field.name}}</th>
    </ng-container>
    <th *ngIf="arrayField.class | valueIncludes : 'has-actions'" class="text-right"></th>
    </thead>

    <ng-container *ngFor="let object of arrayField.value; let i = index">
      <tr class="cursor-pointer bg-hover-slightly-faded-gradient overflow-hidden position-relative {{tableRowsClass}}"
          matRipple>
        <td class="{{tableIndexCellsClass}}"> {{i + 1}} </td>
        <ng-container *ngFor="let field of tableFields; let j = index">
          <td (click)="fs.isAttachmentField(field)? viewAttachment(field.value,field.key):viewDetails(object)"
              class=" d-xl-table-cell {{tableCellsClass}} {{field.class}}"
              style="z-index: 4;">
            <ng-container [ngTemplateOutletContext]="{field}" [ngTemplateOutlet]="valueDisplay"></ng-container>
          </td>
        </ng-container>

        <td *ngIf="arrayField.class | valueIncludes : 'has-actions'"
            class="padding-10 text-right  d-xl-table-cell {{tableCellsClass}} ">
          <button (click)="onEdit.emit({element:object,key:arrayField.key})"
                  *ngIf="(arrayField.class | stringBetween : '[') | valueIncludes : 'edit' "
                  class="buttons-row-col move-right me-3 border bg-gradient-slightly-faded box-shadow-faded  {{animation}}"
                  mat-mini-fab matTooltip="Edit Member"
                  style="--order:3" type="button">
            <mat-icon class="icon-small" svgIcon="edit"></mat-icon>
          </button>

          <button (click)="onDelete.emit({element:object,key:arrayField.key})"
                  *ngIf="(arrayField.class | stringBetween : '[') | valueIncludes : 'delete' "
                  class="buttons-row-col move-right me-3 box-shadow-faded bg-danger-gradient text-white {{animation}}"
                  mat-mini-fab
                  matTooltip="Remove Member" style="--order:3.5" type="button">
            <mat-icon class="icon-small" svgIcon="delete"></mat-icon>
          </button>

          <button (click)="onCustom.emit({element:object,key:arrayField.key})"
                  *ngIf="(arrayField.class | stringBetween : '[') | valueIncludes : 'custom' "
                  class="buttons-row-col move-right me-3 box-shadow-faded bg-gradient-slightly-faded  border {{animation}}"
                  mat-mini-fab
                  matTooltip="Remove Member" style="--order:3.5" type="button">
            <mat-icon [svgIcon]="((arrayField.class | stringBetween : '[') | split : '-' )?.[1] ?? 'take_action'"
                      class="icon-small"></mat-icon>
          </button>
        </td>
      </tr>
    </ng-container>
  </table>
</ng-template>


<!-- ACTION TEMPLATE -->
<ng-template #actions let-object="object">
  <div *ngIf="object?.hasActions" class="row mx-0">
    <div class="col-12">
      <button (click)="onEdit.emit(object)" class="float-left  m-2 bg-gradient-faded bg-hover-slightly-gradient
        border-faded rounded-slight box-shadow-slight scale-up"
              mat-flat-button
              matTooltip="{{ 'Edit' }}">
        <span class="icon-holder"><mat-icon class="pr-2" svgIcon="edit"></mat-icon>
        </span>
        <span>{{'Edit'}}</span>
      </button>

      <button (click)="onDelete.emit(object)" class="float-left m-2 bg-danger-gradient
        border-faded rounded-slight box-shadow-slight scale-up text-white"
              mat-flat-button
              matTooltip="{{ 'Delete' }}">
        <span class="icon-holder"><mat-icon class="pr-2" svgIcon="delete"></mat-icon>
        </span>
        <span>{{'Delete' }}</span>
      </button>
    </div>
  </div>
</ng-template>


<!-- ACTION TEMPLATE -->
<ng-template #notification let-object="object">
  <div *ngIf="object?.hasNotification" class="position-absolute top-right w-100
    h-100 d-flex justify-content-start align-items-center">
    <span class="round box-10 border d-inline-block bg-info blink"
          style="--order:5; transform: translateX(10px);">
    </span>
  </div>
</ng-template>
